import { useSheetSurface } from "@ui/components/SheetSurface";
import { Sheet } from "@ui/primitives/Sheet";
import { sheetHandle } from "./sheet-chrome.styles";

/**
 * The mobile sheet grabber: a Silk Handle spanning the sheet's top edge, so
 * the pill zone both signals and drives swipe-to-dismiss (Silk provides the
 * keyboard/screen-reader affordance).
 */
export function SurfaceHandle() {
  const { platform } = useSheetSurface();
  const styles = sheetHandle({ platform });

  return (
    // The Handle button IS the pill — Silk renders Handle children visually
    // hidden (as the accessible name), so a child span would be invisible.
    <div className={styles.zone()}>
      <Sheet.Handle action="dismiss" className={styles.pill()} />
    </div>
  );
}
